module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\n  <app-polizas-consultar></app-polizas-consultar>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/polizas/polizas.component.html
// module id = ./src/app/Contabilidad/polizas/polizas.component.html
// module chunks = main